import {
  VIDEO_SERVICE_INITIALIZED,
  VISIT_RESUMED,
  VISIT_ENDED
} from 'actions/visits'

// mapping where key is redux action type, value is name of method to call from videoService (e.g. LiveKitVideoService)
const actionHandlers = {
  [VISIT_RESUMED]: 'publishLocalTracks',
  [VISIT_ENDED]: 'sendDataDogErrorIfFaceHasBeenNeverDetected'
}

let videoService

export default ({ dispatch, getState }) => next => action => {
  // special action type to just store reference to the video service. no need to proceed to reducer for this action type
  if (action.type === VIDEO_SERVICE_INITIALIZED) {
    videoService = action.videoService
    return
  }

  // call action handler from service if exists
  const handlerName = actionHandlers[action.type]
  if (handlerName && videoService && videoService[handlerName]) {
    videoService[handlerName]()
  }

  // proceed to reducer
  return next(action)
}


